// extracted by mini-css-extract-plugin
export default {"rating":"uQ-z","numberOfStars":"vQ-z","count":"wQ-z","barGraphSpacing":"xQ-z","barGraph":"yQ-z"};